import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import LocalMallIcon from '@material-ui/icons/LocalMall';
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Select,
	Input,
	InputLabel,
	TableSortLabel,
	MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
	Card,
	CardContent,
	Breadcrumbs,
	Typography,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles,withStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies, isLoggedIn, timeZoneChanger} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	disabled: {},
});

const InventoryAdjustment = () => {
	const classes = useStyles();
	const x = 0;
	const [supplier, setSupplier] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const [warehouseFilter, setWarehouseFilter] = useState(null);
	const [typeFilter, setTypeFilter] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	const [btnDisabled, setBtnDisabled] = useState(true);

	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.suppliername,
	};

	const [selectedDate, setSelectedDate] = React.useState(null);

	useEffect(() => { //
		timeZoneChanger(setSelectedDate);
		isLoggedIn();
	}, [x]);

	useEffect(() => {
		if (typeFilter && warehouseFilter && selectedDate) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [warehouseFilter, typeFilter, selectedDate]);

	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: (option) => option.description
	};
	const selectTypeProps = {
		options: ["Positive","Negative"], //if positive = set value as plus, negative = minus
		getOptionLabel: (option) => option
	};
	
	const getSupplierList = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'/get_supplier_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		});
		setSupplier(result.data.data);
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const data = async () => {
		//get data for location/warehouse dropdown
		const res = await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list');
		setWarehouse(res.data.data);
		getSupplierList();
	};

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LocalMallIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/inventory">
						<h2 className="header-title">Inventory</h2>
					</NavLink>
					<Typography color="textPrimary">Inventory Adjustment</Typography>
				</Breadcrumbs>
			</div>
			{supplier && warehouse ?(			<div className="page-container">
				<Grid container spacing={3}>
					<Grid item xs="3"></Grid>
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Inventory Adjustment Information</h4>
								<form noValidate autoComplete="off">
								<MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											maxDate={new Date()}
											minDate={new Date().setMonth(new Date().getMonth() - 1)}
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="date-picker-inline"
											label="Transaction Date"
											value={selectedDate}
											onChange={handleDateChange}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											inputProps={{readOnly:"true"}}
										/>
									</MuiPickersUtilsProvider>	
								<Autocomplete
										{...selectTypeProps}
										id="auto-complete-2"
										autoComplete
										includeInputInList
										renderInput={(params) => (
											<TextField
												{...params}
												margin="normal"
												label="Type"
												variant="outlined"
											/>
										)}
										onChange={(e, newValue) => {
											if (newValue === "Positive"){
												setTypeFilter('plus');
											}else if(newValue === "Negative"){
												setTypeFilter('minus');
											}else{
												setTypeFilter(null);
											}
										}}
									/>
									<Autocomplete
										{...selectLocationProps}
										id="auto-complete-2"
										autoComplete
										includeInputInList
										renderInput={(params) => (
											<TextField
												{...params}
												margin="normal"
												label="Select Location"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												setWarehouseFilter(newValue.id);
											}else{

												setWarehouseFilter(null);
											}
										}}
									/>
								</form>
							</CardContent>
						</Card>
					</Grid>
					<Grid item sm="4"></Grid>
					<Grid item xs="12" sm="5" className={classes.buttonContainer}>
					{btnDisabled ? (<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    						root: classes.root, 
       			 			disabled: classes.disabled}}>
								Next
							</ColorButton>) : (<NavLink to={'/inventory/inventory-adjustment-information/'+warehouseFilter+'/'+typeFilter+'/'+format(new Date(selectedDate), "yyyy-MM-dd")}>
							<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    						root: classes.root, 
       			 			disabled: classes.disabled}}>
								Next
							</ColorButton>
						</NavLink>)}
					</Grid>
				</Grid>
			</div>
		) :(<Preloader/>)}
		</div>
	);
};
export default InventoryAdjustment;
